'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdCastConnected = function MdCastConnected(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm35 5c1.8 0 3.4 1.6 3.4 3.4v23.2c0 1.8-1.6 3.4-3.4 3.4h-11.6v-3.4h11.6v-23.2h-30v5h-3.4v-5c0-1.8 1.6-3.4 3.4-3.4h30z m-33.4 11.6c10.1 0 18.4 8.2 18.4 18.4h-3.4c0-8.3-6.7-15-15-15v-3.4z m30-5v16.8h-9.3c-2.1-6.6-7.4-11.9-13.9-14v-2.8h23.2z m-30 11.8c6.5 0 11.8 5.1 11.8 11.6h-3.4c0-4.6-3.7-8.4-8.4-8.4v-3.2z m0 6.6c2.8 0 5 2.3 5 5h-5v-5z' })
        )
    );
};

exports.default = MdCastConnected;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/cast-connected.js
// module id = 1349
// module chunks = 168707334958949